/**
 * @generated SignedSource<<269bee0930166946aef69c9345e0bba9>>
 * @relayHash 057ec41627fba08987bd3f2c823823bb
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 057ec41627fba08987bd3f2c823823bb

import { ConcreteRequest } from 'relay-runtime';
export type chMedicationRelationsByDiagnosisCodeQuery$variables = {
  appointmentId: string;
  diagnosisCode: string;
  patientId: string;
};
export type chMedicationRelationsByDiagnosisCodeQuery$data = {
  readonly ch_medicationRelationsByDiagnosisCode: ReadonlyArray<{
    readonly medicationName: string;
    readonly medicationTemplateId: number | null;
    readonly pharmacode: number;
  }>;
};
export type chMedicationRelationsByDiagnosisCodeQuery = {
  response: chMedicationRelationsByDiagnosisCodeQuery$data;
  variables: chMedicationRelationsByDiagnosisCodeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "appointmentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "diagnosisCode"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "appointmentId",
        "variableName": "appointmentId"
      },
      {
        "kind": "Variable",
        "name": "diagnosisCode",
        "variableName": "diagnosisCode"
      },
      {
        "kind": "Variable",
        "name": "patientId",
        "variableName": "patientId"
      }
    ],
    "concreteType": "MedicationSuggestionByDiagnosisCode",
    "kind": "LinkedField",
    "name": "ch_medicationRelationsByDiagnosisCode",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "medicationName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "medicationTemplateId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pharmacode",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "chMedicationRelationsByDiagnosisCodeQuery",
    "selections": (v3/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "chMedicationRelationsByDiagnosisCodeQuery",
    "selections": (v3/*:: as any*/)
  },
  "params": {
    "id": "057ec41627fba08987bd3f2c823823bb",
    "metadata": {},
    "name": "chMedicationRelationsByDiagnosisCodeQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "129ab277b2347f59234ce704bdc1e164";

export default node;
